import * as TypesPrepare from '../types/types_prepare';
import * as TypesPoints from '../types/types_points';
import Vue from 'vue';

export default {
    state: {
        info: {
            coursewareId: '',
            name: ''
        }
    },
    mutations: {
        [TypesPrepare.PREPARE_SET_INFO](state, payload) {
            if (payload) {
                state.info = { coursewareId: payload.coursewareId, name: payload.name };
            } else {
                state.info = {
                    coursewareId: '',
                    name: ''
                };
            }
        },
        [TypesPrepare.PREPARE_SET_SESSION_NAME](state, payload) {
            // payload 参数 name(课程标题)
            state.info.name = payload || '';
        }
    },
    actions: {
    // 开始备课获取课程基本信息
        [TypesPrepare.PREPARE_GET_INFO](ctx, coursewareId) {
            // console.log('id--', coursewareId);
            // let apiUrl = `/v1/online-coursewares/5b4eb08500005e1e2cb66865`;
            let apiUrl = `/v1/online-coursewares/${coursewareId}`;
            return Vue.http.get(apiUrl)
                .then(resp => {
                    return Vue.checkResp(resp, {});
                }).then(data => {
                    // console.log(data)
                    let info = Object.keys(data).length ? { coursewareId, name: data.name } : null;
                    ctx.commit(TypesPrepare.PREPARE_SET_INFO, info);
                    // 数据塞入知识点展示及练习系统
                    // console.log(info)
                    ctx.commit(TypesPoints.POINTS_SET_ITEMS, data);
                    return data;
                }).catch(err => {
                    ctx.commit(TypesPrepare.PREPARE_SET_INFO, null);
                    ctx.commit(TypesPoints.POINTS_SET_ITEMS, null);
                    throw err;
                });
        },
        [TypesPrepare.PREPARE_MODIFY_SESSION_NAME](ctx, { name }) {
            ctx.commit(TypesPrepare.PREPARE_SET_SESSION_NAME, name);
            ctx.commit(TypesPoints.POINTS_SYNC_SESSION_NAME, name);
        },
        // 使用讲义替换当前知识点 actions
        [TypesPrepare.PREPARE_USE_COURSEWARE](ctx, { sessionName, knowledgePoint }) {
            // 会改变课节名称，及替换当前知识点
            if (sessionName) {
                ctx.commit(TypesPrepare.PREPARE_SET_SESSION_NAME, sessionName);
            }
            ctx.commit(TypesPoints.POINTS_REPLACE_POINT, { sessionName, knowledgePoint });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_prepare.js